import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import { ErrorWrapper } from '../ServiceError/components/ErrorWrapper';
import { topPremiumIcon } from '../ServiceError/icons';
import { generateErrorBannerShowAction } from '../../../../../../actions/webview';
import { AppContext } from '../../../../../../../AppModulesWrapper';

import * as styles from './ImportOfferPromotionUnavailable.css';

export const ImportOfferPromotionUnavailable = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('import-offer-promotion-unavailable-error-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorWrapper icon={topPremiumIcon}>
      <div className={styles['wrapper']}>
        <UIText2>Вы можете купить Топ, Премиум только со счёта агентства</UIText2>
      </div>
    </ErrorWrapper>
  );
};
